module.exports = __webpack_public_path__ + "img/indigent5_7-8-2021.c504a871.jpg";